import { forwardRef, type Ref, type SVGProps } from "react";
const IconAIMagicFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M17.704 18.596 8.59 27.71a1 1 0 0 1-1.414 0l-.707-.707a1 1 0 0 1 0-1.414l9.115-9.116zM25 16c.18 0 .3.12.3.299v.03a2.4 2.4 0 0 0 2.4 2.388.3.3 0 0 1 .3.298c0 .179-.12.298-.3.299a2.4 2.4 0 0 0-2.4 2.387c0 .18-.12.299-.3.299s-.3-.12-.3-.299a2.4 2.4 0 0 0-2.4-2.387c-.18 0-.3-.12-.3-.3 0-.178.12-.297.3-.297 1.32 0 2.4-1.075 2.4-2.389v-.03c0-.178.12-.298.3-.298m-5.805-3.138a1 1 0 0 1 1.414 0l.707.707a1 1 0 0 1 0 1.414l-2.198 2.199-2.12-2.122zM11 2.944c.42 0 .7.279.7.697v.069c0 3.065 2.52 5.572 5.6 5.572a.7.7 0 0 1 .7.697c0 .417-.28.697-.7.697-3.08 0-5.6 2.507-5.6 5.572 0 .418-.28.696-.7.696s-.7-.278-.7-.696c0-3.065-2.52-5.572-5.6-5.572-.42 0-.7-.28-.7-.697 0-.418.28-.697.7-.697 3.08 0 5.6-2.507 5.6-5.572v-.07c0-.417.28-.696.7-.696M23.35 4c.24 0 .4.16.4.398v.04c0 1.75 1.44 3.184 3.2 3.184.2 0 .4.159.4.398 0 .238-.16.398-.4.398-1.76 0-3.2 1.433-3.2 3.184 0 .238-.16.398-.4.398s-.4-.16-.4-.398c0-1.751-1.44-3.184-3.2-3.184-.24 0-.4-.16-.4-.398s.16-.398.4-.398c1.76 0 3.2-1.433 3.2-3.184v-.04c0-.238.16-.398.4-.398"
    />
  </svg>
);
const ForwardRef = forwardRef(IconAIMagicFilledSVG);
ForwardRef.displayName = "IconAIMagicFilled";
export { ForwardRef as IconAIMagicFilled };
